module.exports = __webpack_public_path__ + "static/img/back.01d7876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataBrain/back.png
// module id = uEF7
// module chunks = 1